import { useAuth0, type Auth0ContextInterface } from '@auth0/auth0-react';
import { useMemo } from 'react';

export interface IAuthUser {
  sub: string;
  email?: string;
  name?: string;
  family_name?: string;
  given_name?: string;
  nickname?: string;
  picture?: string;
  email_verified?: boolean;
  [key: string]: unknown;
}

export interface IUseAuthReturn {
  user?: IAuthUser;
  isAuthenticated: boolean;
  isLoading: boolean;
  error?: Error;
  loginWithRedirect: Auth0ContextInterface['loginWithRedirect'];
  logout: () => void;
  getAccessTokenSilently: Auth0ContextInterface['getAccessTokenSilently'];
}

export const useAuth = (): IUseAuthReturn => {
  const {
    user,
    isAuthenticated,
    isLoading,
    error,
    loginWithRedirect,
    logout: auth0Logout,
    getAccessTokenSilently,
  } = useAuth0();

  const logout = () => {
    auth0Logout({
      logoutParams: {
        returnTo: `${window.location.origin}/login`,
      },
    });
  };

  const authUser = useMemo(() => {
    if (!user) return undefined;

    return {
      sub: user.sub || '',
      email: user.email,
      name: user.name,
      picture: user.picture,
      email_verified: user.email_verified,
      ...user,
    } as IAuthUser;
  }, [user]);

  return {
    user: authUser,
    isAuthenticated,
    isLoading,
    error,
    loginWithRedirect,
    logout,
    getAccessTokenSilently,
  };
};
